import "../css/blog-archive.css";
// El primer post se muestra como destacado en pantallas grandes, pero no en móviles. Para evitar que el diseño se rompa, se le asigna la clase "featured_post" al primer post solo en pantallas grandes. En pantallas pequeñas, esta clase se elimina para que el diseño sea más fluido y adaptativo.
function toggleFeaturedPost() {
  const li = jQuery('ul.wp-block-post-template li:first-of-type');
  if (jQuery(window).width() > 1180) {
    li.addClass('featured_post');
  } else {
    li.removeClass('featured_post');
  }
}
jQuery(document).ready(function () {
  console.log("blog-archive.js loaded");
  toggleFeaturedPost();
  jQuery(window).on('resize', toggleFeaturedPost);
});